<ng-container *ngIf="!isPreview; else elseTemplate">
  <form [formGroup]="myForm" novalidate>
    <div class="row">
      <ng-container *ngFor="let col of tableHeads">
        <div *ngIf="col.isInputAdd" class="col-md-12 col-xl-12">
          <nz-form-item class="mb-4">
            <nz-form-label [nzSpan]="5" class="text-start">
              {{col.attr}} <span *ngIf="col.isRequire" style="color: red; padding-left: 3px;">(*)</span></nz-form-label>
            <ng-container [ngSwitch]="col.filter?.type" *ngIf="col.isInputAdd">
              <nz-form-control [nzSpan]="19" [nzErrorTip]="errors">
                <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX">
                  <label
                    nz-checkbox
                    [formControlName]="col.name"
                    [nzDisabled]="col.isDisabled">
                  </label>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.INPUT_NUMBER">
                  <input
                    inputNumber class="w-100" nz-input type="text"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [maxlength]="18" #inputInputNumberRef
                  >
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.INT">
                  <input
                    inputNumber class="w-100" nz-input type="text" [attr.maxlength]="col.maxlength!"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" #inputIntRef vssUiAutoCplControl
                    [vssUiAutocomplete]="col.filter?.name || col.name"
                    [disabledAutoComplete]="!(col.filter?.name || col.name).includes('phone') && !(col.filter?.name || col.name).includes('tel')"
                    [maxlength]="col?.filter?.maxLength || 4000"
                  >
                </ng-container>
                <ng-container *ngSwitchCase="colDateTypes.includes(col?.filter?.type!) ? col.filter?.type : -1">
                  <vss-ui-date-picker
                    dateFormat
                    [formControlName]="col.name"
                    [csShowToday]="true"
                  ></vss-ui-date-picker>
                    <!-- [csShowTime]="COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_PICKER == col?.filter?.type" -->
                    <!-- [csRangePicker]="COLUMN_TYPE.DATE_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type" -->
                </ng-container>
                <ng-container
                  *ngSwitchCase="col?.filter?.type == COLUMN_TYPE.SELECT || col?.filter?.type == COLUMN_TYPE.SELECT_INT ? col?.filter?.type : -1">
                  <vss-ui-select-box #csSelectScrollComponent
                    [formControlName]="col.name"
                    [optionList]="col?.filter?.options || []" [getOptionsApi]="col?.filter?.apiSearch!"
                    [keySearch]="col?.filter?.keySearch ||'keyword'" addressSelector
                    [asType]="col?.filter?.addressSelectorType!"
                    [asReferenceId]="getKeyFilterByColName(col?.filter?.referenceColName! || '')"
                    vssUiSelectDir
                    [selectOptionsType]="col?.filter?.selectOptionsType!"
                    [csMaxTagCount]="col?.filter?.csMaxTagCount!"
                    [params]="col?.filter?.params!" (onClose)="null"
                    [csMode]="col?.filter?.multiple ? 'multiple' : 'default'" fieldId="userName"
                    [csPlaceHolder]="col?.filter?.placeholder || col.attr"
                    [csAllowClear]="col?.filter?.csAllowClear !== undefined ? col?.filter?.csAllowClear! : true"
                    [csDropdownMatchSelectWidth]="true"></vss-ui-select-box>
                  <!-- (ngModelChange)="null" -->
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TAG">
                  <nz-select
                    class="w-100" [nzOptions]="col.options || []"
                    [nzPlaceHolder]="col?.filter?.placeholder || col.attr"
                    [formControlName]="col.name"
                    nzShowSearch
                    nzAllowClear></nz-select>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TEXTAREA">
                  <textarea
                    rows="4" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    #inputTextareaRef
                  ></textarea>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.NUMBER">

                  <input
                    inputNumber class="w-100" nz-input type="text"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [maxlength]="18" #inputNumberRef
                  >
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.RECORDING_FILE">

                </ng-container>

                <ng-container *ngSwitchCase="COLUMN_TYPE.ACTION">

                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_CENTER">
                  <input
                    type="text" ng-trim="true" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    #inputTextCenterRef
                  />
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.RANGE_NUMBER">
                  <vss-ui-range-number
                    suffix="%" [classes]="'text-center'"
                    [formControlName]="col.name"></vss-ui-range-number>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <input
                    type="text" ng-trim="true" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    vssUiAutoCplControl [vssUiAutocomplete]="col.filter?.name || col.name" #inputDefaultRef
                    [attr.columnType]="col.name"
                  />
                </ng-container>
              </nz-form-control>
            </ng-container>
          </nz-form-item>
        </div>
      </ng-container>
    </div>
    <div class="me-n4 ms-n4 mb-n4 border mt-4 p-3" *ngIf="!canEdit">
        <div class="text-center">
            <button nz-button nzType="default" class="me-3 colorBtn" type="button" (click)="closeModal()"><i nz-icon nzType="close-circle" nzTheme="outline" aria-hidden="true"></i>Thoát</button>
            <!-- <button nz-button nzType="primary" class="me-3" type="button" *ngIf="!item || canEdit" (click)="submit()"><i nz-icon nzType="check-circle" nzTheme="outline" aria-hidden="true"></i>{{ 'BUTTON.SAVE' | translate }}</button> -->
        </div>
    </div>
  </form>
</ng-container>
<ng-template #elseTemplate>
  <form [formGroup]="myForm" novalidate>
    <div class="row filter-form-modal" cdkDropList (cdkDropListDropped)="dropFilterForm($event)">
      <div *ngFor="let col of tableHeads" cdkDrag  [cdkDragData]="col">
        <div *ngIf="col.isInputAdd" class="col-md-12 col-xl-12">
          <div class="example-custom-placeholder" *cdkDragPlaceholder ></div>
          <nz-form-item class="mb-4">
            <nz-form-label [nzSpan]="5" class="text-start">
              <ng-container *ngIf="!col?.isEditColAttr; else editColTemplate">
                <span (click)="col!.isEditColAttr = true">{{col.attr}}</span>
              </ng-container>
              <ng-template #editColTemplate>
                <input nz-input type="text" class="input-edit"(keyup.enter)="onChangeColAttrValue(col)" (blur)="onChangeColAttrValue(col)" [placeholder]="col.name" [(ngModel)]="col.attr" [ngModelOptions]="{standalone: true}">
              </ng-template>
              <span *ngIf="col.isRequire" style="color: red; padding-left: 3px;">(*)</span></nz-form-label>
            <ng-container [ngSwitch]="col.filter?.type" *ngIf="col.isInputAdd">
              <nz-form-control [nzSpan]="19" [nzErrorTip]="errors">
                <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX">
                  <label
                    nz-checkbox
                    [formControlName]="col.name"
                    [nzDisabled]="col.isDisabled">
                  </label>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.INPUT_NUMBER">
                  <input
                    inputNumber class="w-100" nz-input type="text"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [maxlength]="18" #inputInputNumberRef
                  >
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.INT">
                  <input
                    inputNumber class="w-100" nz-input type="text" [attr.maxlength]="col.maxlength!"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" #inputIntRef vssUiAutoCplControl
                    [vssUiAutocomplete]="col.filter?.name || col.name"
                    [disabledAutoComplete]="!(col.filter?.name || col.name).includes('phone') && !(col.filter?.name || col.name).includes('tel')"
                    [maxlength]="col?.filter?.maxLength || 4000"
                  >
                </ng-container>
                <ng-container *ngSwitchCase="colDateTypes.includes(col?.filter?.type!) ? col.filter?.type : -1">
                  <vss-ui-date-picker
                    dateFormat
                    [formControlName]="col.name"
                    [csShowToday]="true"
                  ></vss-ui-date-picker>
                    <!-- [csShowTime]="COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_PICKER == col?.filter?.type" -->
                    <!-- [csRangePicker]="COLUMN_TYPE.DATE_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type" -->
                </ng-container>
                <ng-container
                  *ngSwitchCase="col?.filter?.type == COLUMN_TYPE.SELECT || col?.filter?.type == COLUMN_TYPE.SELECT_INT ? col?.filter?.type : -1">
                  <vss-ui-select-box #csSelectScrollComponent
                    [formControlName]="col.name"
                    [optionList]="col?.filter?.options || []" [getOptionsApi]="col?.filter?.apiSearch!"
                    [keySearch]="col?.filter?.keySearch ||'keyword'" addressSelector
                    [asType]="col?.filter?.addressSelectorType!"
                    [asReferenceId]="getKeyFilterByColName(col?.filter?.referenceColName! || '')"
                    vssUiSelectDir
                    [selectOptionsType]="col?.filter?.selectOptionsType!"
                    [csMaxTagCount]="col?.filter?.csMaxTagCount!"
                    [params]="col?.filter?.params!" (onClose)="null"
                    [csMode]="col?.filter?.multiple ? 'multiple' : 'default'" fieldId="userName"
                    [csPlaceHolder]="col?.filter?.placeholder || col.attr"
                    [csAllowClear]="col?.filter?.csAllowClear !== undefined ? col?.filter?.csAllowClear! : true"
                    [csDropdownMatchSelectWidth]="true"></vss-ui-select-box>
                  <!-- (ngModelChange)="null" -->
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TAG">
                  <nz-select
                    class="w-100" [nzOptions]="col.options || []"
                    [nzPlaceHolder]="col?.filter?.placeholder || col.attr"
                    [formControlName]="col.name"
                    nzShowSearch
                    nzAllowClear></nz-select>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TEXTAREA">
                  <textarea
                    rows="4" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    #inputTextareaRef
                  ></textarea>
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.NUMBER">

                  <input
                    inputNumber class="w-100" nz-input type="text"
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [maxlength]="18" #inputNumberRef
                  >
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.RECORDING_FILE">

                </ng-container>

                <ng-container *ngSwitchCase="COLUMN_TYPE.ACTION">

                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_CENTER">
                  <input
                    type="text" ng-trim="true" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    #inputTextCenterRef
                  />
                </ng-container>
                <ng-container *ngSwitchCase="COLUMN_TYPE.RANGE_NUMBER">
                  <vss-ui-range-number
                    suffix="%" [classes]="'text-center'"
                    [formControlName]="col.name"></vss-ui-range-number>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <input
                    type="text" ng-trim="true" nz-input
                    [formControlName]="col.name"
                    [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                    vssUiAutoCplControl [vssUiAutocomplete]="col.filter?.name || col.name" #inputDefaultRef
                    [attr.columnType]="col.name"
                  />
                </ng-container>
              </nz-form-control>
            </ng-container>
          </nz-form-item>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="!isPreview" class="me-n4 ms-n4 mb-n4 border mt-4 p-3">
      <div class="text-center">
          <button nz-button nzType="default" class="me-3 colorBtn" type="button" (click)="closeModal()"><i nz-icon nzType="close-circle" nzTheme="outline" aria-hidden="true"></i>Thoát</button>
          <!-- <button nz-button nzType="primary" class="me-3" type="button" *ngIf="!item || canEdit" (click)="submit()"><i nz-icon nzType="check-circle" nzTheme="outline" aria-hidden="true"></i>{{ 'BUTTON.SAVE' | translate }}</button> -->
      </div>
  </div>
</ng-template>
<ng-template #errors let-control>
    <render-errors [data]="control"></render-errors>
</ng-template>
